import { CustomerLead } from '../domain/customerLead.model'
import CustomerRepository from '../repository/customer.repository'
import OfferRepository from '../repository/offer.repository'
import { getOfferDocumentId } from '../services/storage.service'

export default {
  getCustomer: async function() {
    const offer = await OfferRepository.getOfferDocument(getOfferDocumentId())
    return offer.data.customerLead
  },

  saveCustomer: async function(customer: CustomerLead) {
    return CustomerRepository.putCustomer(customer)
  },

  contactMe: async function() {
    return CustomerRepository.contactMe()
  },
}
